import { useState, useEffect } from "react";
import {
    Box,
    Button,
    TextField,
    Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Field, Form, Formik, useFormik } from "formik";
import axios from "axios";
import auth from "../route_rules/auth";
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import * as React from 'react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { DataGrid, GridColDef, GridValueGetterParams } from '@mui/x-data-grid';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { IApplication } from "../interfaces/IApplication";
import { setApplicationValues, setPageTitle } from "../slices/applicationSlice";
import { useAppSelector, useAppDispatch } from "../hooks";


const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        secondary: { main: '#93bd1e' },
        primary: { main: '#AAA' }
    },
});

const columns: GridColDef[] = [
    { field: 'material', headerName: 'Material', width: 130 },
    { field: 'description', headerName: 'Description', width: 130 },
    { field: 'size', headerName: 'Size', width: 130 },
];

interface WorkLogRow {
    description: string,
    material: string,
    size: string,
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function Settings() {

  const dispatch = useAppDispatch();

  useEffect(() => {
    let appState: IApplication = {
      pageTitle: "Patching List",
      backgroundPath: "/assets/images/mainbg.jpg"
    }
    dispatch(setPageTitle(appState));
  }, []);

    const [age, setAge] = React.useState('');

    const handleChangeCrew = (event: SelectChangeEvent) => {
      setAge(event.target.value);
    };


    const [errorMessage, setErrorMessage] = useState({ error: "" });
    const [rows, setRows] = useState<WorkLogRow[]>([]);
    const [completeRows, setCompleteRows] = useState<WorkLogRow[]>([]);
    const [value, setValue] = React.useState(0);

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_ENDPOINT}/api/WorkLogs`)
            .then(res => {
                console.log("NOT COMPLETE", res.data);
                setRows(res.data);
            });
    }, []);

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_ENDPOINT}/api/WorkLogs/true`)
            .then(res => {
                console.log("COMPLETE", res.data);
                setCompleteRows(res.data);
            });
    }, []);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };
    let items = [];
    let history = useNavigate();
    const validate = (values: { password: any; email: string }) => {
        const errors = { password: "", email: "" };

        if (!values.password) {
            errors.password = "This password field is required";
        }

        if (!values.email) {
            errors.email = "This email field is Required";
        } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
        ) {
            errors.email = "Please input a valid email";
        }

        return errors;
    };
    const formik = useFormik({
        initialValues: {
            email: "",
            password: "",
        },
        validate,
        onSubmit: (values) => {
            console.log(values);

            axios
                .post("shared/auth/user/login", {
                    email: formik.values.email,
                    password: formik.values.password,
                })
                .then((response) => {
                    console.log(response);
                    let loginToken = response.data.access_token;
                    localStorage.setItem("token", JSON.stringify(loginToken));

                    auth.login(() => {
                        history("/dashboard");
                    });
                })
                .catch((error) => {
                    if (error.response !== undefined) {
                        console.log(error.response);
                        setErrorMessage(error.response.data);
                    }
                });
        },
    });

    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#666666' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        border: 0,
        borderRadius: 0,
        boxShadow: "none",

    }));



    function createData(
        name: string,
        calories: number,
        fat: number,
        carbs: number,
        protein: number,
    ) {
        return { name, calories, fat, carbs, protein };
    }


    const style = {
        margin: 0,
        top: 'auto',
        right: 20,
        bottom: 20,
        left: 'auto',
        position: 'fixed',
    };

    const handleDelete = () => {
        console.info('You clicked the delete icon.');
      };

      const [open, setOpen] = React.useState(false);

      const handleClickOpen = () => {
        setOpen(true);
      };
    
      const handleClose = () => {
        setOpen(false);
      };

    return (
        <Grid container spacing={0}  >
            <Grid item xs={12}>
                <Item sx={{ bgcolor: 'rgba(255, 255, 255, 0.85)', height: 'calc(100vh - 60px)' }}>
                    <Grid container spacing={1} padding={2}>
                        <Grid item xs={12} >
                            <Item sx={{ bgcolor: 'transparent' }}><Typography variant="h3" color='#000' sx={{ fontWeight: '600', textAlign: 'left', mt: 1 }}>Settings</Typography>
                                <Divider sx={{ marginY: 1 }} />
                            </Item>
                        </Grid>
                        <Grid item xs={3}>
                            <Item sx={{ bgcolor: 'transparent'}}>      
                            <FormControl fullWidth variant="filled">
                                <InputLabel id="demo-simple-select-helper-label">Select</InputLabel>
                                    <Select
                                    sx={{textAlign:"left"}}
                                    labelId="demo-simple-select-helper-label"
                                    id="demo-simple-select-helper"
                                    value={age}
                                    label="Age"
                                    onChange={handleChangeCrew}
                                    >
                                        <MenuItem value="">A</MenuItem>
                                        <MenuItem value={10}>B</MenuItem>
                                        <MenuItem value={20}>C</MenuItem>
                                </Select>
                            </FormControl>
                            </Item>
                        </Grid>
                        <Grid item xs={3} sx={{ marginBottom: 1 }}>
                            <Item sx={{ bgcolor: 'transparent' }}><TextField required variant="filled" fullWidth id="barcode" label="Barcode" color='primary' /></Item>
                        </Grid>
                        <Grid item xs={3}>
                            <Item sx={{ bgcolor: 'transparent' }}><TextField required variant="filled" fullWidth id="greenhouse" label="Greenhouse" /></Item>
                        </Grid>
                        <Grid item xs={3}>
                            <Item sx={{ bgcolor: 'transparent' }}><TextField required variant="filled" fullWidth id="bay" label="Bay" /></Item>
                        </Grid>
                        <Grid item xs={3}>
                            <Item sx={{ bgcolor: 'transparent' }}><TextField required variant="filled" fullWidth id="zone" label="Zone" /></Item>
                        </Grid>
                        <Grid item xs={3}>
                            <Item sx={{ bgcolor: 'transparent' }}><TextField required variant="filled" fullWidth id="bench" label="Bench" /></Item>
                        </Grid>
                        <Grid item xs={3}>
                            <Item sx={{ bgcolor: 'transparent' }}><TextField required variant="filled" fullWidth id="bench" label="Bench" /></Item>
                        </Grid>
                        <Grid item xs={3}>
                            <Item sx={{ bgcolor: 'transparent' }}><TextField required variant="filled" fullWidth id="bench" label="Bench" /></Item>
                        </Grid>
                        <Grid item xs={3}>
                            <Item sx={{ bgcolor: 'transparent' }}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    color="secondary"
                                    sx={{ p: 2 }}
                                    size="large"
                                    endIcon={<PlayArrowIcon />}
                                >
                                    <Typography variant="h5">
                                        Save
                                    </Typography>
                                </Button>
                            </Item>
                        </Grid>
                    </Grid>
                </Item>
            </Grid>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Add Employee</DialogTitle>
                <DialogContent>
                <DialogContentText>
                    <Typography sx={{mb:3}}>Please select the employee you would like to add.</Typography>
                </DialogContentText>
                <FormControl fullWidth variant="filled">
                                <InputLabel id="demo-simple-select-helper-label">Select Employee</InputLabel>
                                    <Select
                                    sx={{textAlign:"left"}}
                                    labelId="demo-simple-select-helper-label"
                                    id="demo-simple-select-helper"
                                    value={age}
                                    label="Age"
                                    onChange={handleChangeCrew}

                                    >
                                        <MenuItem value="">Employee A</MenuItem>
                                        <MenuItem value={10}>Employee B</MenuItem>
                                        <MenuItem value={20}>Employee C</MenuItem>
                                </Select>
                            </FormControl>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button color="success" variant="contained" onClick={handleClose}>Add Employee</Button>
                </DialogActions>
            </Dialog>
        </Grid>
        
    );
}